var map = {
	"./amarelle.mp4": 107,
	"./barbezat_fuchs.mp4": 108,
	"./borloz.mp4": 109,
	"./buclin.mp4": 110,
	"./buffat.mp4": 111,
	"./de_benedictis.mp4": 112,
	"./dittli.mp4": 113,
	"./gorrite.mp4": 114,
	"./keller.mp4": 115,
	"./luisier.mp4": 116,
	"./morand.mp4": 117,
	"./ruiz.mp4": 118,
	"./venizelos.mp4": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;